// src/store/effects/festival.effects.ts
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { FestivalActions } from '../actions/festival.actions';
import { FestivalThemeService } from '../../core/festival/festival-theme.service';
import { FestivalTheme } from '../../core/festival/festival.config';

@Injectable()
export class FestivalEffects {

  private actions$ = inject(Actions);
  private festivalService = inject(FestivalThemeService);

  loadFestivalTheme$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FestivalActions.loadFestivalTheme),
      switchMap(({ countryCode }) =>
        this.festivalService.fetchFestivals(countryCode).pipe(
          map((apiResponse: any) => {            
            const festivals: FestivalTheme[] = apiResponse?.data ?? [apiResponse]
            const activeFestival = festivals.length
              ? festivals.reduce((prev, curr) =>
                  Math.abs(curr.daysRemaining) < Math.abs(prev.daysRemaining)
                    ? curr
                    : prev
                )
              : null;

            this.festivalService.applyThemeFromData(apiResponse);

            return FestivalActions.loadFestivalThemeSuccess({
              festivals,
              activeFestival,
            });
          }),
          catchError((error) => {
            console.error('[Festival Effect] Error:', error);
            return of(
              FestivalActions.loadFestivalThemeFailure({
                error: error?.message ?? 'Unknown error',
              })
            );
          })
        )
      )
    )
  );

  clearFestivalTheme$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(FestivalActions.clearFestivalTheme),
        map(() => this.festivalService.clearTheme())
      ),
    { dispatch: false }
  );
}